import * as types from '../../actions/actionTypes';
import initialState from '../initialState';

export default function keywordsPacksReducer(state = initialState.keywordsPacks, action) {
    let newState;

    switch (action.type) {
        case types.LOAD_KEYWORDS_PACKS_SUCCESS:
            return action.keywordsPacks;

        case types.CREATE_KEYWORDS_PACK_SUCCESS:
            return [...state];

        case types.UPDATE_KEYWORDS_PACK_SUCCESS:
            return [
                ...state.data.filter(keywordsPack => keywordsPack.id !== action.keywordsPack.id),
                {...action.keywordsPack}
            ];

        case types.DELETE_KEYWORDS_PACK_SUCCESS:
            newState = {...state};
            newState.data = newState.data.filter(keywordsPack => keywordsPack.id !== action.keywordsPack);
            newState.total = newState.total - 1;
            return newState;
        default:
            return state;
    }
}


// WEBPACK FOOTER //
// ./web/src/reducers/keywords-pack/keywordsPacksReducer.js